import { Box } from "@mui/material";
import React from "react";
import ErrorScreen from "../screens/generic-screens/ErrorScreen";
import DesktopUser from "../../assets/svgs/desktop_user.svg";
import { useDashLayoutCtx } from "../screens/dashboard/DashLayoutCtxProvider";

function DesktopOnlyView({ children }) {
  const { logOutFromDashboard } = useDashLayoutCtx();
  return (
    <>
      <Box sx={{ display: { xs: "none", sm: "block" } }}>{children}</Box>
      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        <ErrorScreen
          customErrorImage={DesktopUser}
          customErrorMsg={
            "Your screen is too small. Please use a tablet (landscape mode) or desktop for the best experience."
          }
          imageSize="250px"
          action={logOutFromDashboard}
          actionLabel="Log Out"
        />
      </Box>
    </>
  );
}

export default DesktopOnlyView;
